import { isString } from 'lodash';

import type { Maybe } from './globals';

export const STOP_TRANSLATE_KEYWORDS: readonly string[] = [
  // English
  'STOP TRANSLATION',
  'STOP TRASLATION',
  'STOP TRANSLATE',
  'STOP TRASLATE',

  // Spanish
  'DETENER TRADUCCIÓN',
  'DETENER TRADUCCION',
  'DETENER TRADUCION',
  'DETENER TRADDUCCION',
  'DETENER TRADUCTION',
  'DETENER TRADUC',
  'DEETENER TRADUCCION',
  'DETNER TRADUCCION',
  'PARAR TRADUCCIÓN',
  'PARAR TRADUCCION',
  'PARAR TRADUCION',
  'PARAR TRADUC',
  'STOP TRADUCCIÓN',
  'STOP TRADUCCION',

  // French Canadian
  'ARRÊTER TRADUCTION',
  'ARRETER TRADUCTION',
  'ARETER TRADUCTION',
  'ARRÉTER TRADUCTION',
  'ARRETER TRADUCTOIN',
  'ARRETER TRADUCTON',
  'ARRETER TRADUTION',
  'ARRÊTER TRADUCTON',
  'ARRETE TRADUCTION',
  'ARRETEZ TRADUCTION',
  'CESSER TRADUCTION',
  'CESSER LA TRADUCTION',
  'ARRETER TRADUC',
  'STOP TRADUCTION',

  // Brazilian Portuguese
  'PARAR TRADUÇÃO',
  'PARAR TRADUCAO',
  'PARAR TRADUÇAO',
  'PARAR TRADUCÃO',
  'PARAR TRADUCA0',
  'PARAR TRADUZAO',
  'PARA TRADUÇÃO',
  'PARA TRADUCAO',
  'PARAR TRAD',
  'PARAR A TRADUÇÃO',
  'PARAR A TRADUCAO',

  // Russian Cyrillic + romanized
  'СТОП ПЕРЕВОД',
  'СТОП ПЕРЕВОДИ',
  'СТОП ПЕРЕВОДТ',
  'СТОП ПЕЕРВОД',
  'СТОП ПЕРЕВДО',
  'СТОП ПЕРЕВОТ',
  'СТОП ПЕРЕОД',
  'СТОП ПЕРЕВ',
  'ВЫКЛ ПЕРЕВОД',
  'ОТКЛ ПЕРЕВОД',
  'ОТКЛЮЧИТЬ ПЕРЕВОД',
  'STOP PEREVOD',
  'STOP PEREOVD',
  'STOP PEREVOT',
  'STOP PERVOD',
  'VYKL PEREVOD',
  'OTKL PEREVOD',

  // Ukrainian Cyrillic + romanized
  'СТОП ПЕРЕКЛАД',
  'СТОП ПЕРЕКЛА',
  'СТОП ПЕРЕКДАД',
  'СТОП ПЕРЕКАЛД',
  'СТОП ПИРЕКЛА',
  'СТОП ПЕРЕКЛ',
  'ЗУПИНИТИ ПЕРЕКЛАД',
  'ЗУПИНИ ПЕРЕКЛАД',
  'ЗУПИН ПЕРЕКЛАД',
  'ВИКЛ ПЕРЕКЛАД',
  'ВІДКЛ ПЕРЕКЛАД',
  'STOP PEREKLAD',
  'STOP PEREKLA',
  'ZUPYNYTY PEREKLAD',
  'ZUPYNY PEREKLAD',
  'VIKL PEREKLAD',

  // Punjabi Gurmukhi + romanized
  'ਅਨੁਵਾਦ ਬੰਦ',
  'ਅਨੁਵਾਦ ਬਨਦ',
  'ਅਨੁਵਾਦਬੰਦ',
  'ANUVAD BAND',
  'ANUWAD BAND',
  'ANUVAAD BAND',
  'ANUAD BAND',
  'ANUVAD BUND',
  'ANUVAD BND',
  'ANUVAD BHAND',
  'ANUVAD BEND',
  'ANUVAD BAAND',
  'ANUVAD BANDH',

  // Hindi Devanagari + romanized
  'अनुवाद रोकें',
  'अनुवाद रोको',
  'अनुवाद रोके',
  'अनुवादरोकें',
  'ANUVAD ROKEIN',
  'ANUVAD ROKEN',
  'ANUVAD ROKAIN',
  'ANUVAD ROKE',
  'ANUWAD ROKEIN',
  'ANUVAAD ROKEIN',
  'ANUVAD ROKHEIN',
  'ANUVAD ROKIEN',
  'ANUVAD ROKNE',

  // Tagalog
  'ITIGIL PAGSASALIN',
  'ITIGIL PAGSALIN',
  'ITIGIL PAGSASLIN',
  'ITIGIL PAGASALIN',
  'ITIGIL PAGSASALN',
  'ITIGIL PAGSASALING',
  'TIGIL PAGSASALIN',
  'TIGIL PAGSALIN',
  'ITIGIL SALIN',
  'ITIGIL ANG PAGSASALIN',
  'ITIGIL ANG SALIN',
  'ITTIGIL PAGSASALIN',
  'ITGIL PAGSASALIN',

  // Haitian Creole
  'KANPE TRADIKSYON',
  'KANPE TRADIKSON',
  'KANPE TRADIKSION',
  'KANPE TRADIKYON',
  'KANPE TRADUKSYON',
  'KANPE TRADISYON',
  'KANP TRADIKSYON',
  'KANPE TRADIKSYO',
  'KANPE TRADUCTION',
  'KANPE TRADIK',
  'RETE TRADIKSYON',
  'RETE TRADIKSON'
];

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/gu, '\\$&');
}

const STOP_TRANSLATE_PATTERN = new RegExp(
  `^(?:${STOP_TRANSLATE_KEYWORDS.map(escapeRegExp).join('|')})$`,
  'iu'
);

export function isStopTranslate(content: Maybe<string>): boolean {
  if (!isString(content)) {
    return false;
  }
  return STOP_TRANSLATE_PATTERN.test(content.trim());
}

export function shouldSkipTranslation(input: {
  direction: 'inbound' | 'outbound';
  translationEnabled?: boolean | null;
  driverTranslationEnabled?: boolean | null;
}): boolean {
  if (input.direction === 'inbound') {
    return input.translationEnabled === false;
  }
  return input.driverTranslationEnabled === false;
}
